<template>
  <div class="upgrad_details">
    <div class="text-content" v-html="dataDetails.content"></div>
  </div>
</template>
<script>
import utils from '@/utils/common'
export default {
  data() {
    return {
      dataDetails:'',
    };
  },
  methods: {
   getDetails(){
     this.http({
       url:'/order/app/functionInfo/'+this.$route.query.id,
       method:'get'
     }).then(rps=>{
       if(rps.code==200){
         this.dataDetails = rps.data;
         document.title = rps.data.title;
         utils.nativeMethod({tm:1000003,tp:{title:rps.data.title}})
       }
     })
     this.$loading.hide();
   }
  },
  created() {
    if(this.$route.query.id){
      this.getDetails();
    }
  },
};
</script>
<style lang="less" scoped>
.upgrad_details{
  margin-top: 10px;
}
.text-content{
  font-size: 24px;
  padding: 40px 30px;
  img{
    max-width: 100% ;
  }
}
</style>